import { z } from 'zod';

export const agentDataSourceRecordSchema = z.object({
  id: z.uuid(),
  agentId: z.coerce.number(),
  brandId: z.coerce.number().nullable(),
  dataSourceId: z.uuid(),
  isEnabled: z.boolean(),
  addedBy: z.coerce.number().nullable(),
  addedOn: z.coerce.date(),
  dataSource: z.object({
    id: z.uuid(),
    name: z.string(),
    description: z.string().nullable(),
    queryHint: z.string().nullable(),
    sourceIdentifier: z.string(),
    dataConnectionId: z.uuid(),
    dataConnection: z.object({
      identifier: z.uuid(),
      name: z.string(),
    }),
  }),
});

export type AgentDataSourceRecord = z.infer<typeof agentDataSourceRecordSchema>;
